import { createSlice } from "@reduxjs/toolkit";
import { findById, indexById } from "../helpers";

export const setupsSlice = createSlice({
  name: "setup",
  initialState: {
    chosenID: 0,
    mySetups: []
  },
  reducers: {
    UPLOAD_SETUPS: (state, action) => {
      state.mySetups = action.payload;
      for (const setup of action.payload) {
        if (setup.type !== "combine") {
          state.chosenID = setup.ID;
          break;
        }
      }
    },
    CHOOSE_SETUP: (state, action) => {
      state.chosenID = action.payload;
    },
    REMOVE_SETUP: (state, action) => {
      const removedID = action.payload;
      const { mySetups } = state;
      const visibleIDs = mySetups.reduce((filtered, st) => {
        if (st.type !== "combined") {
          filtered.push(st.ID);
        }
        return filtered;
      }, []);
      mySetups.splice(indexById(mySetups, removedID), 1);
      const removedIndexInVisible = visibleIDs.indexOf(removedID);
      const lastIndex = visibleIDs.length - 1;
      const newID =
        removedIndexInVisible === lastIndex
          ? visibleIDs[lastIndex - 1] || 0
          : visibleIDs[removedIndexInVisible + 1];
      state.chosenID = newID;
    },
    COMBINE_SETUPS: (state, action) => {
      const { pickedIDs, name } = action.payload;
      const { mySetups } = state;
      const allIDs = {};
      for (const ID of pickedIDs) {
        const setup = findById(mySetups, ID);
        setup.type = "combined";
        allIDs[setup.char.name] = ID;
      }
      const ID = Date.now();
      mySetups.unshift({
        name,
        ID,
        type: "complex",
        shownID: pickedIDs[0],
        allIDs
      });
      state.chosenID = ID;
    },
    ADD_TO_COMPLEX: ({ mySetups }, action) => {
      const { complexID, pickedIDs } = action.payload;
      pickedIDs.forEach((ID, i) => {
        const setup = findById(mySetups, ID);
        setup.type = "combined";
        findById(mySetups, complexID).allIDs[setup.char.name] = ID;
      });
    },
    UNCOMBINE_COMPLEX: ({ mySetups }, action) => {
      const index = indexById(mySetups, action.payload);
      for (const ID of Object.values(mySetups[index].allIDs)) {
        findById(mySetups, ID).type = "original";
      }
      mySetups.splice(index, 1);
    },
    SWITCH_SETUP_ON_COMPLEX: (state, action) => {
      const { complexID, newID } = action.payload;
      findById(state.mySetups, complexID).shownID = newID;
    },
    SAVE_SETUP: (state, action) => {
      const { mySetups } = state;
      const { ID, name, data } = action.payload;
      const existed = findById(mySetups, ID);
      let newChosenID;
      if (existed?.type === "combined") {
        for (const setup of mySetups) {
          if (
            setup.type === "complex" &&
            setup.allIDs[existed.char.name] === ID
          ) {
            newChosenID = setup.ID;
            setup.shownID = ID;
            break;
          }
        }
      }
      const newSetup = {
        name,
        ID,
        type: existed ? existed.type : "original",
        ...data
      };
      if (existed) mySetups[indexById(mySetups, ID)] = newSetup;
      else mySetups.unshift(newSetup);
      state.chosenID = newChosenID || ID;
    },
    CALCULATOR_UPDATE_SETUPS: ({ mySetups }, action) => {
      const [wp, arts, actionIs] = action.payload;
      if (actionIs[1]) {
        for (const setup of mySetups) {
          if (setup.type !== "complex" && setup.weapon.ID === wp.ID) {
            setup.weapon = { ...setup.weapon, ...wp };
          }
        }
      }
      actionIs[2].forEach((actI, i) => {
        if (!actI) return;
        for (const { type, art } of mySetups) {
          if (type !== "complex" && art.pieces[i].ID === arts[i].ID) {
            art.pieces[i] = arts[i];
          }
        }
      });
    }
  }
});

export const {
  UPLOAD_SETUPS,
  CHOOSE_SETUP,
  REMOVE_SETUP,
  COMBINE_SETUPS,
  ADD_TO_COMPLEX,
  UNCOMBINE_COMPLEX,
  SWITCH_SETUP_ON_COMPLEX,
  SAVE_SETUP,
  CALCULATOR_UPDATE_SETUPS
} = setupsSlice.actions;

export const selectMySetups = (state) => state.setups.mySetups;

export const selectChosenSetupID = (state) => state.setups.chosenID;

export default setupsSlice.reducer;
